interface MoneyProps {
  ore: number;
  currency?: string;
}

export function Money({ ore, currency = 'kr' }: MoneyProps) {
  const v = (ore / 100).toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return (
    <span>
      {v} <span className="text-slate-500">{currency}</span>
    </span>
  );
}
